import _ from 'lodash';

export default function parseAddressComponents(address_components) {
    let components = {};

    _.each(address_components, (component) => {
        _.each(component.types, (type) => {
            components[type] = component.long_name;
        });
    });

    return components;
}


// WEBPACK FOOTER //
// ./src/app/utils/parseAddressComponents.js